import { FC, useEffect } from "react";
import { IAttempt } from "@miplatform/types";
import { Box } from "@mui/material";
import { WorkOrderAttemptDocumentStep } from "./WorkOrderAttemptDocumentStep/WorkOrderAttemptDocumentStep";
import { useWorkOrderAttemptDocumentFormViewModel } from "./useWorkOrderAttemptDocumentFormViewModel";

interface WorkOrderAttemptDocumentFormProps {
  attempt: IAttempt | null;
  isViewMode?: boolean;
  isLoading?: boolean;
  onClose: () => void;
  onRefresh: () => void;
}

export const WorkOrderAttemptDocumentForm: FC<
  WorkOrderAttemptDocumentFormProps
> = ({ attempt, isViewMode, isLoading, onClose, onRefresh }) => {
  const { step, documentCategories, getDocumentCategory } =
    useWorkOrderAttemptDocumentFormViewModel({ attempt, onClose });

  useEffect(() => {
    getDocumentCategory();
  }, []);

  return (
    <Box display="flex" flexDirection="column" flexGrow={1} gap={3} pb={2}>
      {step && (
        <WorkOrderAttemptDocumentStep
          isViewMode={isViewMode}
          attempt={attempt}
          step={step}
          isLoading={isLoading}
          documentCategories={documentCategories}
          onRefresh={onRefresh}
        />
      )}
    </Box>
  );
};
